import { useState } from 'react';

export default function Footer() {
  const [wechatHovered, setWechatHovered] = useState(false);

  return (
    <footer className="bg-[#F8F6F2] text-gray-800">
      <div className="max-w-[1400px] mx-auto px-6 py-6">
        <div className="flex flex-col md:flex-row md:items-center gap-6">
          {/* Brand Column */}
          <div className="flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/d6d1f2a32b22918380a2589cd9f5379c/24d32a4bc4a641f4b085ce8ca2481df2.png"
              alt="星贸云"
              className="h-[90px] w-auto object-contain"
            />
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-8 bg-gray-200 flex-shrink-0"></div>

          {/* Contact Row */}
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            {/* WeChat QR */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setWechatHovered(true)}
              onMouseLeave={() => setWechatHovered(false)}
            >
              <button className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#14B8A6] transition-colors cursor-pointer group whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-wechat-line text-sm text-[#07C160]"></i>
                </span>
                <span>微信扫码咨询</span>
                <i className="ri-qr-code-line text-xs text-gray-400"></i>
              </button>

              {wechatHovered && (
                <div className="absolute bottom-full left-0 mb-3 z-50">
                  <div className="bg-white rounded-xl shadow-xl border border-gray-100 p-3 w-36">
                    <div className="w-full aspect-square bg-gray-50 rounded-lg flex flex-col items-center justify-center border border-gray-100 mb-2 overflow-hidden">
                      <img
                        src="https://public.readdy.ai/ai/img_res/2d730550918c35898c21ead86b061446.jpg"
                        alt="微信二维码"
                        className="w-full h-full object-cover rounded"
                      />
                    </div>
                    <p className="text-xs text-center text-gray-500 leading-snug">扫码添加企业微信<br />获取专属顾问服务</p>
                  </div>
                  <div className="w-3 h-3 bg-white border-r border-b border-gray-100 rotate-45 ml-4 -mt-1.5 shadow-sm"></div>
                </div>
              )}
            </div>

            <a
              href="mailto:ceo@g4b.cn"
              className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#14B8A6] transition-colors cursor-pointer group whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line text-sm text-gray-400 group-hover:text-[#14B8A6]"></i>
              </span>
              <span>ceo@g4b.cn</span>
            </a>

            <a
              href="tel:+8613360027991"
              className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#14B8A6] transition-colors cursor-pointer group whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm text-gray-400 group-hover:text-[#14B8A6]"></i>
              </span>
              <span>13360027991</span>
            </a>

            <div className="flex items-center gap-1.5 text-sm text-gray-400 whitespace-nowrap">
              <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-sm"></i>
              </span>
              <span>工作日 09:00–18:00</span>
            </div>
          </div>

          {/* ICP 备案信息 右对齐 */}
          <div className="md:ml-auto flex items-center gap-2 text-sm text-gray-400 whitespace-nowrap">
            <span>© 2025 星贸云</span>
            <span>·</span>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-gray-600 transition-colors cursor-pointer"
            >
              粤ICP备XXXXXXXX号
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
